module.exports = __webpack_public_path__ + "static/media/2021winner-joanne.8c840e74.jpg";